import type {SketchCollectionObject} from '../sketch/SketchCollectionObject';
import {hasRuntimeFlag} from './hasRuntimeFlag';

/**
 * 判断对象是否为草图集合对象。
 * @param value 待判断对象。
 * @returns 当对象满足草图集合协议时返回 true。
 */
export function isSketchCollectionObject(value: unknown): value is SketchCollectionObject {
	// 通过统一的布尔标记识别集合对象。
	return hasRuntimeFlag(value, 'isSketchCollectionObject');
}
